module.exports = __webpack_public_path__ + "static/media/fleet.3bde832b.svg";